import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'

interface UseGetMessageVolumeTrendsParams {
  fromDate?: string
  pageId: string
  period: 'overall' | 'daily' | 'weekly' | 'monthly'
  toDate?: string
}

export const useGetMessageVolumeTrendsQuery = (
  params: UseGetMessageVolumeTrendsParams
) => {
  return useQuery({
    enabled: !!params.pageId,
    queryFn: async () => {
      const { data } =
        await AnalyticsApi.v1Private.inboxAnalysisMessageVolumeTrendsList(
          params,
          {
            format: 'json',
          }
        )
      return data
    },
    queryKey: [
      QueryKey.GET_MESSAGE_VOLUME_TRENDS,
      params.pageId,
      params.period,
      params.fromDate,
      params.toDate,
    ],
  })
}
